package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.LayersOutline: ImageVector
    get() {
        if (_layersOutline != null) {
            return _layersOutline!!
        }
        _layersOutline = Builder(name = "LayersOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 13.0f, viewportHeight = 13.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(6.1442f, 12.8739f)
                lineTo(0.0f, 8.0999f)
                lineTo(0.9202f, 7.3932f)
                lineTo(6.1442f, 11.4374f)
                lineTo(11.3682f, 7.3932f)
                lineTo(12.2884f, 8.0999f)
                lineTo(6.1442f, 12.8739f)
                verticalLineTo(12.8739f)
                moveTo(6.1442f, 9.548f)
                lineTo(0.0f, 4.774f)
                lineTo(6.1442f, 0.0f)
                lineTo(12.2884f, 4.774f)
                lineTo(6.1442f, 9.548f)
                verticalLineTo(9.548f)
                moveTo(6.1442f, 4.774f)
                verticalLineTo(4.774f)
                verticalLineTo(4.774f)
                verticalLineTo(4.774f)
                verticalLineTo(4.774f)
                verticalLineTo(4.774f)
                moveTo(6.1442f, 8.1115f)
                lineTo(10.4567f, 4.774f)
                lineTo(6.1442f, 1.4365f)
                lineTo(1.8317f, 4.774f)
                lineTo(6.1442f, 8.1115f)
                verticalLineTo(8.1115f)
            }
        }
        .build()
        return _layersOutline!!
    }

private var _layersOutline: ImageVector? = null
